var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSignup(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-3"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 382.4,
    width: 500,
    height: 0.25,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 91.7,
    y: 397.53,
    width: 33.12,
    height: 0.25,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62.03,
    y: 397.53,
    width: 19.19,
    height: 0.25,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 191.36,
    y: 401.21,
    width: 19.19,
    height: 0.25,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 267.42,
    y: 406.79,
    width: 43.19,
    height: 0.25,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 252.19,
    y: 406.79,
    width: 6.33,
    height: 0.25,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 359.67,
    y: 401.21,
    width: 93.68,
    height: 0.25,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237,337.8H43.91a5.71,5.71,0,0,1-5.7-5.71V60.66A5.71,5.71,0,0,1,43.91,55H237a5.71,5.71,0,0,1,5.71,5.71V332.09A5.71,5.71,0,0,1,237,337.8ZM43.91,55.2a5.46,5.46,0,0,0-5.45,5.46V332.09a5.46,5.46,0,0,0,5.45,5.46H237a5.47,5.47,0,0,0,5.46-5.46V60.66A5.47,5.47,0,0,0,237,55.2Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.31,337.8H260.21a5.72,5.72,0,0,1-5.71-5.71V60.66A5.72,5.72,0,0,1,260.21,55h193.1A5.71,5.71,0,0,1,459,60.66V332.09A5.71,5.71,0,0,1,453.31,337.8ZM260.21,55.2a5.47,5.47,0,0,0-5.46,5.46V332.09a5.47,5.47,0,0,0,5.46,5.46h193.1a5.47,5.47,0,0,0,5.46-5.46V60.66a5.47,5.47,0,0,0-5.46-5.46Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 245.41,
    y: 296.98,
    width: 21.99,
    height: 87.23,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "263.22 384.21 267.4 384.21 267.4 372.33 258.84 372.33 263.22 384.21",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 149.05,
    y: 296.98,
    width: 21.99,
    height: 87.23,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 167.4,
    y: 296.98,
    width: 100,
    height: 79.94,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.77,300.91v21.15H171V300.91h92.74m.39-.39H170.64v21.92h93.52V300.52Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "171.57 384.21 167.4 384.21 167.4 372.33 175.95 372.33 171.57 384.21",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.19,311.48a2.21,2.21,0,1,0,2.21-2.21A2.21,2.21,0,0,0,215.19,311.48Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.77,326.37v21.15H171V326.37h92.74m.39-.38H170.64v21.92h93.52V326Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.19,337a2.21,2.21,0,1,0,2.21-2.21A2.21,2.21,0,0,0,215.19,337Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.77,351.84V373H171V351.84h92.74m.39-.39H170.64v21.93h93.52V351.45Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.19,362.42a2.21,2.21,0,1,0,2.21-2.22A2.21,2.21,0,0,0,215.19,362.42Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 135.62,
    y: 246.32,
    width: 21.99,
    height: 137.9,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "153.43 384.21 157.61 384.21 157.61 372.33 149.06 372.33 153.43 384.21",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 53.44,
    y: 246.32,
    width: 21.99,
    height: 137.9,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 71.78,
    y: 246.32,
    width: 85.83,
    height: 130.61,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.91,250v29.57H75.48V250h78.43m.46-.45H75V280h79.35V249.56Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.91,283.18v78.43H116.55V283.18h37.36m.46-.46H116.1v79.35h38.27V282.72Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.84,283.18v78.43H75.48V283.18h37.36m.45-.46H75v79.35h38.27V282.72Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "75.96 384.21 71.78 384.21 71.78 372.33 80.34 372.33 75.96 384.21",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.48,264.8a2.22,2.22,0,1,0,2.22-2.21A2.22,2.22,0,0,0,112.48,264.8Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.4,320.53a2.22,2.22,0,1,0,2.21-2.22A2.21,2.21,0,0,0,120.4,320.53Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.57,320.53a2.21,2.21,0,1,0,2.21-2.22A2.21,2.21,0,0,0,104.57,320.53Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.07,207.87H92.8a97.94,97.94,0,0,1,1.61,13.62c0,5-7.06,24.83,3,24.83s3-19.78,3-24.83A97.94,97.94,0,0,1,102.07,207.87Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.8,228.15v6a12.18,12.18,0,0,0,12.14,12.14h6a12.18,12.18,0,0,0,12.14-12.14v-6Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.67,284.26c0,7,7.83,12.72,17.4,12.72h8.64c9.57,0,17.4-5.72,17.4-12.72Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.61,274c-5.24,4.28-12.48,12.11-19.1,23.13-4.42,7.34-7.08,15-8.25,25.18,0-11.5.07-23.85.11-35.51,1.33-3,4.37-9.92,6.55-15.38,7.27-18.23,10-22.72,16.53-38.44,8.73-21,17.67-45.86,15.11-43.87-5.22,4.05-25.22,41.5-27.38,46.86a150,150,0,0,0-10.79,44.85c0-11,.08-21,.12-28.76.14-25.31.57-33.48.78-36,.81-1.28,1.76-2.77,2.32-3.57,4.7-6.8,6.51-12.58,10.93-22.72,6.28-14.35,11.68-39.84,10.1-38.56-6.58,5.36-11.76,16.86-18.58,31.53s-4.87,23.1-6.22,35.62c-.28,2.46-.5,11.74-.66,24.59-1.76-13.7-5.08-22.72-11.13-30.92-7.44-10.09-14.64-16.9-19.92-20.46s9.12,21.22,16,32c6.13,9.64,11.78,18.13,15,26.5-.17,17.43-.25,39.49-.25,60-1.58-9.34-4.16-19.41-7.6-27.2-4.14-9.36-10.5-23.72-15.57-28.59-1.21-1.17,5.3,26.76,9.48,34.18s7.25,14.43,9.88,18.64c.61,1,2.65,4.77,3.81,6.95,0,25.07.14,47.19.36,54.72h1.08c-.07-1.94-.09-14.7-.06-31.58,2.61-9.16,8.57-19.62,13.49-29.16C416.11,297.7,429.85,269.75,424.61,274Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "412.44 384.21 381.1 384.21 378.73 353.49 414.81 353.49 412.44 384.21",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "417.14 357.07 376.39 357.07 375.23 346.7 418.31 346.7 417.14 357.07",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68.21,
    y: 75.5,
    width: 56.05,
    height: 61.55,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72.43,
    y: 75.5,
    width: 57.9,
    height: 61.55,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 75.46,
    y: 82.17,
    width: 51.85,
    height: 48.2,
    transform: "translate(207.65 4.89) rotate(90)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88.02,
    y: 93.86,
    width: 26.71,
    height: 24.83,
    transform: "translate(207.65 4.89) rotate(90)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 357.98,
    y: 82.67,
    width: 52.07,
    height: 57.18,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 361.91,
    y: 82.67,
    width: 53.78,
    height: 57.18,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 364.72,
    y: 88.87,
    width: 48.16,
    height: 44.77,
    transform: "translate(500.06 -277.54) rotate(90)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 388.8,
    cy: 111.26,
    r: 13.97,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 140.91,
    y: 112.2,
    width: 41.58,
    height: 45.66,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144.04,
    y: 112.2,
    width: 42.95,
    height: 45.66,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146.29,
    y: 117.15,
    width: 38.46,
    height: 35.75,
    transform: "translate(300.54 -30.49) rotate(90)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "165.52 125.3 155.74 142.24 175.3 142.24 165.52 125.3",
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-3"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 250,
    cy: 416.24,
    rx: 193.89,
    ry: 11.32,
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M349.25,163.43l-9.92-4s-13.09,23.87-16.84,25.08c-5.1,1.64-15.66,6.2-21.92,7-.85,1-2.24,4.11-2.11,5.24,8.41,2.81,26.89-.92,30.85-3.86C338.32,186.22,349.25,163.43,349.25,163.43Z",
    style: {
      fill: "#e58a7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.3,158c1.85,6.83-8.17,20.57-8.17,20.57L331,171.21s2.46-5.65,5.46-11.4C341.27,150.52,350.19,150.21,352.3,158Z",
    style: {
      fill: "#5A887A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.3,158c1.85,6.83-8.17,20.57-8.17,20.57L331,171.21s2.46-5.65,5.46-11.4C341.27,150.52,350.19,150.21,352.3,158Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.21,174.15l5.17,2.9.91-15.87C339.28,163.49,337.16,170.45,336.21,174.15Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.66,152.86s-10.22,22.74-4.26,65.08h40.27c.64-6.18-1.48-36.34,6.19-65.46a102.44,102.44,0,0,0-13.38-1.71,147.88,147.88,0,0,0-17.11,0A78.93,78.93,0,0,0,343.66,152.86Z",
    style: {
      fill: "#5A887A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.66,152.86s-10.22,22.74-4.26,65.08h40.27c.64-6.18-1.48-36.34,6.19-65.46a102.44,102.44,0,0,0-13.38-1.71,147.88,147.88,0,0,0-17.11,0A78.93,78.93,0,0,0,343.66,152.86Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.32,417.14c-.06,1.08,15.21,1.95,34.1,1.95s34.27-.87,34.33-1.95-15.2-1.94-34.1-1.94S334.39,416.07,334.32,417.14Z",
    style: {
      fill: "#e8ecf1",
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 357.82,
    y: 390.96,
    width: 7.68,
    height: 17.09,
    transform: "matrix(0.93, -0.36, 0.36, 0.93, -119.46, 156.75)",
    style: {
      fill: "#e58a7b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "393.05 409.45 385.52 409.45 382.76 392.02 390.29 392.02 393.05 409.45",
    style: {
      fill: "#e58a7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385,408.58h8.46a.62.62,0,0,1,.61.52l1.09,6.69a1.18,1.18,0,0,1-1.18,1.34c-2.95-.05-4.37-.23-8.09-.23-2.29,0-7,.24-10.18.24s-3.39-3.12-2.08-3.41c5.88-1.27,8.16-3,10.12-4.68A1.89,1.89,0,0,1,385,408.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360,406l8-2.34a.65.65,0,0,1,.75.32l3,6a1.15,1.15,0,0,1-.75,1.59c-2.91.8-4.86,1.29-8.5,2.35-2.51.73-5.07,1.92-7.55,2.71-1.72.55-5.76.57-7.85.57-3.09,0-3.78-3.26-2.45-3.41,3.35-.37,3.8-.2,5.65-1.13a25.69,25.69,0,0,0,8.08-5.58A3.75,3.75,0,0,1,360,406Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.83,191.47,293.55,188l-3.41,9.18a34,34,0,0,0,10.24,0Z",
    style: {
      fill: "#e58a7b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "287.39 187.76 287.17 193.86 290.14 197.16 293.55 187.98 287.39 187.76",
    style: {
      fill: "#e58a7b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 356.33,
    y: 391.24,
    width: 7.68,
    height: 8.81,
    transform: "translate(-118.31 156.23) rotate(-21.11)",
    style: {
      fill: "#cf6f64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "390.29 392.02 382.76 392.02 384.19 401.01 391.72 401.01 390.29 392.02",
    style: {
      fill: "#cf6f64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.12,206.49c.15,1.81.32,3.66.54,5.56l29.94-9.72A21.44,21.44,0,0,0,380.12,194c.12-2.67.27-5.48.5-8.41.1-1.42.22-2.88.35-4.36s.31-3.12.5-4.7Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.9,173.69l-1-.12c.59-5,4.32-8.94,8.25-8.84l0,1C351.71,165.66,348.43,169.21,347.9,173.69Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.23,182.92h-.17l0-1c3.44.13,6.67-3.46,7.2-7.93l1,.12C360.73,179,357.12,182.92,353.23,182.92Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.92,131.5c-1.41,5.51-3.07,15.6.56,19.27,0,0-2.54,5.59-12.77,5.59-9.35,0-4.34-5.59-4.34-5.59,6.22-1.46,6.33-6,5.51-10.3Z",
    style: {
      fill: "#e58a7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.42,135.16l-6.53,5.31a17.6,17.6,0,0,1,.35,3c1.91,1.9,5.74-2.91,6.13-5.37A8,8,0,0,0,367.42,135.16Z",
    style: {
      fill: "#cf6f64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.66,131.43a6.61,6.61,0,0,0,4.25,3.14c2.4.53,3.6-1.68,2.94-3.9-.59-2-2.56-4.69-5-4.23A3.34,3.34,0,0,0,349.66,131.43Z",
    style: {
      fill: "#cf6f64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.63,113.8c-3.74,1.71-5.06,16.57-.36,18.77S360.71,110.55,353.63,113.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.06,123.21c-.9,7.46-1,11.85-5,15.67a9.62,9.62,0,0,1-16.36-5.1c-1.21-6.7.46-17.77,7.94-20.74A9.63,9.63,0,0,1,373.06,123.21Z",
    style: {
      fill: "#e58a7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.77,117.66c5.54-1.41,9.61-2.37,8.15,2.24-1.93,6.16-4.25,12.12-1.14,12.39,1.9.17,10.3-3.39,9.23-7-.93-3.14,3-4,3.7-5.59,2.59-5.76-4.82-5-3.5-8.5s-6-9.14-10-6.33c-6.51,4.54-17.68,4.47-11.81-3,4.21-5.33-3.3-4.24-3.3-4.24s4.54,2.69-3.1,6.85C340.92,108.92,348.33,120.85,360.77,117.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376,131.43a7.75,7.75,0,0,1-4.61,3.14c-2.47.53-3.42-1.68-2.49-3.9.83-2,3.11-4.69,5.47-4.23S377.27,129.47,376,131.43Z",
    style: {
      fill: "#e58a7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.4,217.94s-6.76,60.5-7.29,83.46c-.54,23.88,22.91,98.39,22.91,98.39l12-5s-14-68.08-12-91.53c2.12-25.57,10.88-85.28,10.88-85.28Z",
    style: {
      fill: "#5A887A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.2,234.55c-5.39,11.18-1.76,33.29,1.16,46.39,1.11-9.25,2.43-19.29,3.68-28.58C360.92,238.08,359.81,227.05,356.2,234.55Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.49,390.83c.06,0,1.42,3.82,1.42,3.82l-13.84,5.82-2.18-4.06Z",
    style: {
      fill: "#5A887A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.69,217.94s5.17,57.54,8.59,79.09c3.76,23.61,18.5,102.24,18.5,102.24h13.79s-8.26-76.72-9.82-100.1c-1.7-25.36-5.08-81.23-5.08-81.23Z",
    style: {
      fill: "#5A887A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.78,395.68c.06,0,.46,3.85.46,3.85H380.08L379,395.11Z",
    style: {
      fill: "#5A887A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.5,391.12a.13.13,0,0,1-.13-.11c-.08-.7-7.53-70-8.93-91-1.52-22.78-4.58-73.31-4.61-73.82a.12.12,0,0,1,.12-.13h0a.13.13,0,0,1,.13.12c0,.51,3.09,51,4.61,73.82,1.4,21,8.85,90.25,8.92,91a.12.12,0,0,1-.11.14Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.62,125.29c0,.61-.38,1.1-.78,1.1s-.69-.49-.65-1.1.38-1.1.78-1.1S361.66,124.69,361.62,125.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.76,125.29c0,.61-.39,1.1-.78,1.1s-.69-.49-.66-1.1.39-1.1.79-1.1S354.8,124.69,354.76,125.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.92,125.6a23.3,23.3,0,0,1-3.2,5.19c1,1,2.87.54,2.87.54Z",
    style: {
      fill: "#df5753"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.1,133.88a.17.17,0,0,1-.17-.18.19.19,0,0,1,.19-.18,5.12,5.12,0,0,0,4-1.88.19.19,0,0,1,.25,0,.18.18,0,0,1,0,.25A5.46,5.46,0,0,1,357.1,133.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.84,123.45a.34.34,0,0,1-.31,0,2.84,2.84,0,0,0-2.55-.27.34.34,0,0,1-.46-.16.37.37,0,0,1,.19-.48,3.51,3.51,0,0,1,3.23.3.35.35,0,0,1,.09.49A.4.4,0,0,1,362.84,123.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.11,121.45a.29.29,0,0,1-.14-.08.35.35,0,0,1,0-.5,3.74,3.74,0,0,1,3.08-1.24.34.34,0,0,1,.28.41.39.39,0,0,1-.42.3h0a3,3,0,0,0-2.43,1A.37.37,0,0,1,352.11,121.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.73,162.32l-10.4-2.77s-10.2,25.11-13.81,26.74c-4.9,2.24-17.31,10-22.59,13.67-.29,1.25-.06,4.56.6,5.47,9-1.64,26.23-8.27,29.83-11.64C381.57,186.1,389.73,162.32,389.73,162.32Z",
    style: {
      fill: "#e58a7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.47,409.9a2.19,2.19,0,0,1-1.43-.39,1,1,0,0,1-.31-.94.59.59,0,0,1,.34-.5c.84-.43,3.19,1.06,3.46,1.23a.16.16,0,0,1,.07.18.21.21,0,0,1-.14.15A9.48,9.48,0,0,1,382.47,409.9Zm-1-1.56a.53.53,0,0,0-.23,0,.22.22,0,0,0-.12.21.68.68,0,0,0,.2.65c.39.35,1.37.39,2.66.14A6.63,6.63,0,0,0,381.44,408.34Z",
    style: {
      fill: "#5A887A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.41,409.63a.13.13,0,0,1-.08,0c-.75-.42-2.16-2.07-1.95-2.91a.61.61,0,0,1,.59-.47.94.94,0,0,1,.75.23c.83.71.88,2.89.88,3a.15.15,0,0,1-.09.16A.17.17,0,0,1,384.41,409.63Zm-1.34-3.05H383c-.23,0-.26.13-.27.18-.12.49.77,1.74,1.51,2.33a4.14,4.14,0,0,0-.75-2.36A.61.61,0,0,0,383.07,406.58Z",
    style: {
      fill: "#5A887A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.92,408.65a2.87,2.87,0,0,1-1.89,0,.94.94,0,0,1-.49-.76.59.59,0,0,1,.21-.53c.8-.72,4.07,0,4.44.14a.16.16,0,0,1,.12.16.19.19,0,0,1-.11.18A14.64,14.64,0,0,1,355.92,408.65Zm-1.63-1.19a.69.69,0,0,0-.31.15.21.21,0,0,0-.08.21.63.63,0,0,0,.32.51c.53.28,1.76.06,3.35-.61A9.84,9.84,0,0,0,354.29,407.46Z",
    style: {
      fill: "#5A887A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.17,407.84h-.08c-1-.18-3-1.33-3.06-2.19,0-.2.09-.48.57-.64a1.28,1.28,0,0,1,1,.06c1.08.53,1.65,2.45,1.68,2.54a.18.18,0,0,1-.05.17A.18.18,0,0,1,358.17,407.84Zm-2.37-2.53-.1,0c-.31.11-.31.24-.31.28,0,.52,1.45,1.47,2.46,1.79a3.78,3.78,0,0,0-1.4-2A.92.92,0,0,0,355.8,405.31Z",
    style: {
      fill: "#5A887A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.78,199.37l-10.43,4.8-1.21,3,3.85,2.59s7.2-.78,9.25-5.41Z",
    style: {
      fill: "#e58a7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.22,205.6a14.06,14.06,0,0,0-1.94-5.66l1.65-1.24a16.09,16.09,0,0,1,2.32,6.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346,200.79a2,2,0,1,1-2.44-.78A1.82,1.82,0,0,1,346,200.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "326.3 208.05 327.69 209.45 337.05 205.45 333.35 204.17 326.3 208.05",
    style: {
      fill: "#e58a7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.49,390.83c.06,0,1.42,3.82,1.42,3.82l-13.84,5.82-2.18-4.06Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.78,395.68c.06,0,.46,3.85.46,3.85H380.08L379,395.11Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.44,159.44c2.75,8.87-8,21-8,21l-14.85-6.06a154.08,154.08,0,0,1,6.08-15.07C380.23,149.48,389.66,150.49,392.44,159.44Z",
    style: {
      fill: "#5A887A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.44,159.44c2.75,8.87-8,21-8,21l-14.85-6.06a154.08,154.08,0,0,1,6.08-15.07C380.23,149.48,389.66,150.49,392.44,159.44Z",
    style: {
      opacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Screen--inject-3"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 238.49,
    y: 70.57,
    width: 6.39,
    height: 1.03,
    style: {
      fill: "#5A887A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 319.14,
    y: 119.42,
    width: 17.18,
    height: 1.03,
    transform: "translate(193.16 441.94) rotate(-87.42)",
    style: {
      fill: "#5A887A"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "325.61 75.19 207.61 75.19 196.63 320.91 314.63 320.91 325.61 75.19",
    style: {
      fill: "#5A887A"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "322.09 78.57 204.09 78.57 193.11 324.29 311.11 324.29 322.09 78.57",
    style: {
      fill: "#fafafa",
      opacity: 0.56
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "318.57 81.94 200.57 81.94 189.58 327.66 307.58 327.66 318.57 81.94",
    style: {
      fill: "#5A887A",
      opacity: 0.07
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "305.14 189.11 204.42 189.11 203.58 207.91 304.3 207.91 305.14 189.11",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "259.81 175.39 205.03 175.39 204.66 183.8 259.44 183.8 259.81 175.39",
    style: {
      fill: "#5A887A"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "302.87 239.85 202.15 239.85 201.31 258.65 302.03 258.65 302.87 239.85",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "284.4 284.04 216.67 284.04 215.66 306.57 283.39 306.57 284.4 284.04",
    style: {
      fill: "#5A887A",
      opacity: 0.47000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.87,310.07H212.14a.18.18,0,0,1-.09,0,.14.14,0,0,1,0-.09l1-22.54a.11.11,0,0,1,.12-.11h67.73a.09.09,0,0,1,.08,0,.08.08,0,0,1,0,.08L280,310A.13.13,0,0,1,279.87,310.07Zm-67.61-.24h67.49l1-22.3H213.26Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "247.98 226.13 202.76 226.13 202.39 234.55 247.6 234.55 247.98 226.13",
    style: {
      fill: "#5A887A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.11,128.38a26.53,26.53,0,0,1-5.57,15.05A26.88,26.88,0,0,1,256.34,154a24.31,24.31,0,0,1-24.46-25.62,27,27,0,0,1,26.75-25.62A24.29,24.29,0,0,1,283.11,128.38Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.52,108.12a7,7,0,0,1-1.48,4,7.17,7.17,0,0,1-5.64,2.81,6.48,6.48,0,0,1-5.38-2.81,6.61,6.61,0,0,1-1.12-4,7.18,7.18,0,0,1,7.11-6.8A6.46,6.46,0,0,1,285.52,108.12Z",
    style: {
      fill: "#5A887A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.27,198.51a3.19,3.19,0,0,1-3.15,3,2.85,2.85,0,0,1-2.88-3,3.17,3.17,0,0,1,3.15-3A2.86,2.86,0,0,1,215.27,198.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.75,198.51a3.18,3.18,0,0,1-3.15,3,2.85,2.85,0,0,1-2.87-3,3.17,3.17,0,0,1,3.14-3A2.85,2.85,0,0,1,228.75,198.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.24,198.51a3.18,3.18,0,0,1-3.15,3,2.86,2.86,0,0,1-2.88-3,3.18,3.18,0,0,1,3.15-3A2.85,2.85,0,0,1,242.24,198.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213,249.25a3.19,3.19,0,0,1-3.15,3,2.86,2.86,0,0,1-2.88-3,3.18,3.18,0,0,1,3.15-3A2.86,2.86,0,0,1,213,249.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.48,249.25a3.18,3.18,0,0,1-3.14,3,2.85,2.85,0,0,1-2.88-3,3.18,3.18,0,0,1,3.15-3A2.85,2.85,0,0,1,226.48,249.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240,249.25a3.18,3.18,0,0,1-3.15,3,2.87,2.87,0,0,1-2.88-3,3.19,3.19,0,0,1,3.15-3A2.85,2.85,0,0,1,240,249.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.46,249.25a3.19,3.19,0,0,1-3.15,3,2.87,2.87,0,0,1-2.88-3,3.19,3.19,0,0,1,3.15-3A2.86,2.86,0,0,1,253.46,249.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267,249.25a3.19,3.19,0,0,1-3.15,3,2.85,2.85,0,0,1-2.88-3,3.18,3.18,0,0,1,3.15-3A2.86,2.86,0,0,1,267,249.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 257.87,
    cy: 119.82,
    rx: 10.6,
    ry: 10.13,
    transform: "translate(-10.27 214.43) rotate(-44.36)",
    style: {
      fill: "#5A887A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.54,143.43A26.88,26.88,0,0,1,256.34,154a24.27,24.27,0,0,1-20.24-10.57c4.86-4.84,12.55-8,21.07-8S273.11,138.59,277.54,143.43Z",
    style: {
      fill: "#5A887A"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 257.87,
    cy: 119.82,
    rx: 10.6,
    ry: 10.13,
    transform: "translate(-10.27 214.43) rotate(-44.36)",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.54,143.43A26.88,26.88,0,0,1,256.34,154a24.27,24.27,0,0,1-20.24-10.57c4.86-4.84,12.55-8,21.07-8S273.11,138.59,277.54,143.43Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M130.41,212.44c-.95,2.08-1.95,4.37-2.82,6.59s-1.76,4.51-2.53,6.79a86.24,86.24,0,0,0-3.58,13.8l-.22,1.47a2.15,2.15,0,0,0,.07.75,7.8,7.8,0,0,0,1.1,2.32,29.28,29.28,0,0,0,4.44,5,67.35,67.35,0,0,0,5.52,4.61c1.92,1.48,3.94,2.92,5.93,4.28l-1.87,3.51A70.87,70.87,0,0,1,123,253.85a32.39,32.39,0,0,1-6-5.68,14.25,14.25,0,0,1-2.39-4.27,9.7,9.7,0,0,1-.48-3c0-.24,0-.59,0-.76l0-.49.1-1a78.22,78.22,0,0,1,3.27-15.34c.78-2.46,1.61-4.91,2.56-7.3s1.93-4.73,3.14-7.16Z",
    style: {
      fill: "#e58a7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.91,257.43l7.07-3.58-1.83,7.76s-4.85,1.36-7.1-1Z",
    style: {
      fill: "#e58a7b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "150.45 255.12 148.57 261.54 142.15 261.61 143.98 253.85 150.45 255.12",
    style: {
      fill: "#e58a7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.43,175A20,20,0,0,0,162,179a1.63,1.63,0,0,1-1.59.51Z",
    style: {
      fill: "#df5753"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 160.22,
    cy: 173.91,
    rx: 0.75,
    ry: 1.15,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160,172.8l1.52-.43S160.78,173.55,160,172.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.9,182.34c.91,4.65,1.82,13.18-1.44,16.29,0,0,1.28,4.72,9.93,4.72,9.51,0,4.54-4.72,4.54-4.72-5.19-1.24-5.06-5.09-4.15-8.71Z",
    style: {
      fill: "#e58a7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.37,171.74c.48,7.77.52,11.07,4.44,15.06,5.91,6,15.35,3.72,17.2-4,1.67-7,.61-18.52-7-21.61A10.62,10.62,0,0,0,138.37,171.74Z",
    style: {
      fill: "#e58a7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.14,163c-3.9,1.42-9.1.36-7.06,12.39,2.16,12.74-1.16,16.93-1.16,16.93s14.79,3.15,29.89-.19c0,0-4.61-8.06-3.32-14,1.65-7.5.35-10.27.35-10.27S144.62,161,139.14,163Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.64,175.79a7.81,7.81,0,0,0,1.22,4.17c1.06,1.62,2.31,1,2.62-.72.28-1.51.07-4.18-1.28-5.22S155.66,174,155.64,175.79Z",
    style: {
      fill: "#e58a7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.75,164.31c-1.12-3.15,4.22-8,15.52-6s11.79,11.41,11.79,11.41L160.78,167l.1,2.86-11.61,2.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.71,199.16h0a1.77,1.77,0,0,1,1.45-2c3.52-.58,11.52-1.76,15.54-1.2,3,.42,3.78,2.16,3.91,3.59a1.76,1.76,0,0,1-1.85,1.9l-17.38-.78A1.78,1.78,0,0,1,136.71,199.16Z",
    style: {
      fill: "#5A887A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.71,199.16h0a1.77,1.77,0,0,1,1.45-2c3.52-.58,11.52-1.76,15.54-1.2,3,.42,3.78,2.16,3.91,3.59a1.76,1.76,0,0,1-1.85,1.9l-17.38-.78A1.78,1.78,0,0,1,136.71,199.16Z",
    style: {
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "146.76 373.86 153.21 378.34 164 363.71 157.55 359.24 146.76 373.86",
    style: {
      fill: "#e58a7b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "131.72 373.57 138.53 377.45 148.08 361.98 141.27 358.1 131.72 373.57",
    style: {
      fill: "#e58a7b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "163.99 363.71 158.43 371.25 151.98 366.78 157.54 359.24 163.99 363.71",
    style: {
      fill: "#cf6f64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "141.26 358.1 148.08 361.99 143.16 369.96 136.34 366.07 141.26 358.1",
    style: {
      fill: "#cf6f64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.2,248s25.18,31.73,20.45,62.08c-3.81,24.51-25.91,57.7-25.91,57.7l-10.39-5.16a339.26,339.26,0,0,0,18.7-45.44,33.59,33.59,0,0,0-4-29.1c-12.76-18.63-33.2-7.54-19.45-40.08Z",
    style: {
      fill: "#5A887A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.2,248s25.18,31.73,20.45,62.08c-3.81,24.51-25.91,57.7-25.91,57.7l-10.39-5.16a339.26,339.26,0,0,0,18.7-45.44,33.59,33.59,0,0,0-4-29.1c-12.76-18.63-33.2-7.54-19.45-40.08Z",
    style: {
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.55,268.38l-3.66-3.64c0,.29,7.09,44.06,9.08,56.36a74.53,74.53,0,0,0,2.69-11C175,295.21,170.11,280,164.55,268.38Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.44,248s30.32,39.88,31.18,63.79c.71,20-33,58.75-33,58.75l-9.8-6.34s19.73-27.52,24.7-50C174.6,291.92,134,248,134,248Z",
    style: {
      fill: "#5A887A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.44,248s30.32,39.88,31.18,63.79c.71,20-33,58.75-33,58.75l-9.8-6.34s19.73-27.52,24.7-50C174.6,291.92,134,248,134,248Z",
    style: {
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.93,200.41c-3.24.77-6.35,12.55-6.35,12.55l12.67,8.46s4.22-9.32,2.74-13.4C133.46,203.77,130,199.44,125.93,200.41Z",
    style: {
      fill: "#5A887A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.41,208l-.88,10.27,4.71,3.16a42.2,42.2,0,0,0,2.87-9.14Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.19,200.64s3.74,1.31-3.75,47.35H131.58c.54-13,.55-21-5.65-47.58a94.29,94.29,0,0,1,13.53-1.78,101.16,101.16,0,0,1,14.47,0C160.15,199.2,167.19,200.64,167.19,200.64Z",
    style: {
      fill: "#5A887A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.43,208c.72,2,1.48,4.15,2.28,6.22s1.56,4.2,2.37,6.3l2.45,6.28.62,1.57.32.78.15.39c0,.07,0,.07,0,.06a2.06,2.06,0,0,0-.7-.62,2.85,2.85,0,0,0-1.3-.39,2.61,2.61,0,0,0-1.11.21c-.46.21-.46.3-.45.29a1.21,1.21,0,0,0,.22-.23,13.63,13.63,0,0,0,1.43-2.33c.47-.92.92-1.9,1.37-2.89.88-2,1.69-4.07,2.5-6.16s1.58-4.2,2.33-6.33l2.28-6.38,3.85,1c-.76,4.56-1.74,9-2.92,13.52-.57,2.25-1.24,4.48-2,6.73-.38,1.13-.8,2.25-1.28,3.4A21.55,21.55,0,0,1,181,233a9.32,9.32,0,0,1-.88,1.08,5.42,5.42,0,0,1-1.82,1.29,4.48,4.48,0,0,1-1.94.36,4.4,4.4,0,0,1-2.11-.63,5.38,5.38,0,0,1-1.82-1.89c-.15-.26-.28-.52-.37-.71l-.19-.38-.38-.78-.76-1.55c-1-2.08-2-4.18-2.87-6.29s-1.79-4.25-2.65-6.4-1.63-4.3-2.36-6.62Z",
    style: {
      fill: "#e58a7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.19,200.64c3.83.91,8.14,12.23,8.14,12.23l-11.39,9.69s-7.37-12.34-5.88-16.41C159.61,201.91,162.19,199.45,167.19,200.64Z",
    style: {
      fill: "#5A887A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187,201.19l4-3.34,2.78,4.33-2.05,3.61s-3.26,3-6.14,1.47h0A5.17,5.17,0,0,1,187,201.19Z",
    style: {
      fill: "#e58a7b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "198.22 197.86 197.92 198.95 191.59 200.01 190.97 197.85 198.22 197.86",
    style: {
      fill: "#e58a7b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "162.4 371.05 150.98 363.67 153.03 360.11 165.86 368 162.4 371.05",
    style: {
      fill: "#5A887A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143,376.93a6.88,6.88,0,0,1-2.82-1,.18.18,0,0,1,0-.34c.31-.1,3-.93,3.78-.29a.64.64,0,0,1,.22.61,1.06,1.06,0,0,1-.57.86A1.31,1.31,0,0,1,143,376.93Zm-2.25-1.1c1.25.64,2.25.87,2.73.63a.7.7,0,0,0,.36-.58c0-.16,0-.23-.09-.27C143.33,375.27,141.83,375.53,140.73,375.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.25,376a.2.2,0,0,1-.14-.06.19.19,0,0,1,0-.18c0-.09.65-2.26,1.67-2.75a1,1,0,0,1,.83,0,.66.66,0,0,1,.46.67c-.07.9-1.9,2.14-2.74,2.35Zm1.94-2.73a.68.68,0,0,0-.28.07c-.62.3-1.13,1.47-1.38,2.18.88-.37,2.09-1.35,2.13-1.9,0-.09,0-.2-.23-.3A.74.74,0,0,0,142.19,373.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.27,381.25c-1.13,0-2.7-1.45-3.56-2.34a.18.18,0,0,1,0-.21.21.21,0,0,1,.19-.1c.4,0,3.87.52,4.36,1.5a.57.57,0,0,1,0,.58,1,1,0,0,1-.79.56Zm-2.9-2.2c1.26,1.22,2.37,1.9,3,1.82a.68.68,0,0,0,.52-.37.21.21,0,0,0,0-.23C157.63,379.73,155.78,379.27,154.37,379.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.48,379a3.27,3.27,0,0,1-.67-.05.18.18,0,0,1-.14-.11.21.21,0,0,1,0-.19c.06-.07,1.41-1.7,2.69-1.81a1.39,1.39,0,0,1,1,.32c.39.34.37.64.27.83C157.38,378.67,155.65,379,154.48,379Zm-.26-.37c1.12.06,2.91-.31,3.14-.8,0,0,.08-.16-.18-.38a1,1,0,0,0-.76-.24A4.38,4.38,0,0,0,154.22,378.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.52,374.92l-8.48-2.4a.62.62,0,0,0-.75.35l-2.86,6.43a1.26,1.26,0,0,0,.83,1.69c3,.78,4.44,1,8.17,2.07,2.3.64,5.58,1.83,8.75,2.73s4.23-2.19,3-2.85c-5.56-2.94-6-5-7.52-7.2A2.06,2.06,0,0,0,140.52,374.92Z",
    style: {
      fill: "#5A887A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.94,377.74l-7.24-5a.62.62,0,0,0-.82.08l-4.8,5.16a1.25,1.25,0,0,0,.24,1.86c2.55,1.71,3.87,2.4,7.06,4.61,2,1.36,5.87,4.38,8.57,6.26s4.71-.7,3.75-1.72c-4.3-4.59-5.24-7.47-5.95-10.08A2.07,2.07,0,0,0,153.94,377.74Z",
    style: {
      fill: "#5A887A"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "148.07 368.44 135.02 361.95 136.37 358.41 150.31 365.25 148.07 368.44",
    style: {
      fill: "#5A887A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.1,246.12,130,249c-.11.22.15.45.52.45H163.6c.29,0,.53-.14.55-.32l.28-2.86c0-.19-.23-.36-.54-.36H131.62A.61.61,0,0,0,131.1,246.12Z",
    style: {
      fill: "#5A887A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.1,246.12,130,249c-.11.22.15.45.52.45H163.6c.29,0,.53-.14.55-.32l.28-2.86c0-.19-.23-.36-.54-.36H131.62A.61.61,0,0,0,131.1,246.12Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.31,249.73h-.87c-.17,0-.3-.09-.29-.2l.41-3.71c0-.1.16-.19.33-.19h.87c.17,0,.3.09.29.19l-.41,3.71C136.63,249.64,136.48,249.73,136.31,249.73Z",
    style: {
      fill: "#5A887A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.71,249.73h-.86c-.17,0-.3-.09-.29-.2l.4-3.71c0-.1.17-.19.34-.19h.86c.17,0,.31.09.29.19l-.4,3.71C157,249.64,156.89,249.73,156.71,249.73Z",
    style: {
      fill: "#5A887A"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 135.55,
    cy: 417.14,
    rx: 26.79,
    ry: 1.94,
    style: {
      fill: "#f5f5f5",
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.87,414.4c-4.74-1.38-10-3.15-13.18-5-.09-.06-.19-.09-.28-.14V387.8H148a2.86,2.86,0,0,0,0-5.71h-9.54V284.27H132.7v97.82h-9.53a2.86,2.86,0,1,0,0,5.71h9.53v21.43c-.09,0-.18.08-.27.14-3.23,1.88-8.45,3.65-13.19,5a1.4,1.4,0,0,0,.39,2.74h31.85A1.4,1.4,0,0,0,151.87,414.4Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112.6,
    y: 274.31,
    width: 45.92,
    height: 20.93,
    rx: 5.18,
    style: {
      fill: "#5A887A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.45,295.25v1.82c0,1.5,1.63,2.72,3.63,2.72h29c2,0,3.63-1.22,3.63-2.72v-1.82Z",
    style: {
      fill: "#5A887A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.45,295.25v1.82c0,1.5,1.63,2.72,3.63,2.72h29c2,0,3.63-1.22,3.63-2.72v-1.82Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignup);
export default __webpack_public_path__ + "static/media/signup.09c931f956336b4994c0fe79afa67aec.svg";
export { ForwardRef as ReactComponent };